import axios from 'axios';

export default {
    pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_corredores.pre_insercion",
				"p_args_in": JSON.stringify({
                    "p_usuario": p_usuario,
				  })
			})
	},

	consulta_poliza(p_email, p_ejecutivo, p_poliza){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_BaseDatos.fnc_consultaPoliza",
			"p_args_in": JSON.stringify({
				"p_ejecutivo": p_ejecutivo,
				"p_poliza": p_poliza,
			  })
		})
	},

	consulta_contratante(p_email, p_contratante){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_BaseDatos.fnc_consultacontratante",
			"p_args_in": JSON.stringify({
				"p_contratante": p_contratante,
				})
		})
	},
	consulta_corredor(p_email, p_corredor){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_corredores.fnc_consultaCorredor",
			"p_args_in": JSON.stringify({
				"p_codcorredor": p_corredor,
				})
		})
	},
	consulta_contactos(p_email, p_ejecutivo, p_poliza, p_contratante, p_corredor){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_BaseDatos.fnc_ConsultaContactos",
			"p_args_in": JSON.stringify({
				"p_ejecutivo": p_ejecutivo,
				"p_poliza": p_poliza,
				"p_contratante": p_contratante,
				"p_corredor": p_corredor,
				})
		})
	},
	
	// eliminar(p_email, p_usuario,p_gicidinfcorr){
    //     return axios
    //     .post('spoc/modppentry', {
    //         "p_email": p_email,
    //         "p_metodo": "pkg_compp_corredores.eliminar",
    //         "p_args_in": JSON.stringify({
	// 			"p_usuario": p_usuario,
	// 			"p_gicidinfcorr": p_gicidinfcorr
    //             })
    //     })
    // },
	insertar(p_email, p_usuario, p_giccodcorredor, p_gicnomcontacto, p_gicapellcontacto, p_giccargo,
			p_gicmail, p_gictelefonofijo, p_gictelefonomovil, p_giccontactocomcred,
			p_giccontactoventas, p_giccontactosiniestro, p_giccontactogarantia, 
			p_giccontactorecuperos, p_gicdireccionparticular, p_gicciudad, p_giccomuna,
			p_gicfechacumpleanos, p_giccategoriacontacto, p_gicestado, p_gicobservacion,
			p_gicultimamodificacion, p_gicusuario){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_corredores.insertar",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_giccodcorredor": p_giccodcorredor,
				"p_gicnomcontacto": p_gicnomcontacto,
				"p_gicapellcontacto": p_gicapellcontacto,
				"p_giccargo": p_giccargo,
				"p_gicmail": p_gicmail,
				"p_gictelefonofijo": p_gictelefonofijo,
				"p_gictelefonomovil": p_gictelefonomovil,
				"p_giccontactocomcred": p_giccontactocomcred,
				"p_giccontactoventas": p_giccontactoventas,
				"p_giccontactosiniestro": p_giccontactosiniestro,
				"p_giccontactogarantia": p_giccontactogarantia,
				"p_giccontactorecuperos": p_giccontactorecuperos,
				"p_gicdireccionparticular": p_gicdireccionparticular,
				"p_gicciudad": p_gicciudad,
				"p_giccomuna": p_giccomuna,
				"p_gicfechacumpleanos": p_gicfechacumpleanos,
				"p_giccategoriacontacto": p_giccategoriacontacto,
				"p_gicestado": p_gicestado,
				"p_gicobservacion": p_gicobservacion,
				"p_gicultimamodificacion": p_gicultimamodificacion,
				"p_gicusuario": p_gicusuario
				})
		})
	},
	
	editarCorredor(p_email, p_usuario, p_giccodcorredor, p_gicestadocorredor){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_corredores.editarcorredor",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_giccodcorredor": p_giccodcorredor,
				"p_gicestadocorredor": p_gicestadocorredor
				})
		});
	},
	recuperarmantcorr(p_email, p_corredor){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_corredores.recuperarmantcorr",
			"p_args_in": JSON.stringify({
				"p_corredor": p_corredor
				})
		})
	},

	insertupdatcategorias(p_email, p_usuario, p_ccocategoria, p_ccodescripcion){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_corredores.insertupdatcategorias",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_ccocategoria": p_ccocategoria,
				"p_ccodescripcion": p_ccodescripcion
				})
		});
	},

	recuperarcategorias(p_email, p_usuario){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_corredores.recuperarcategorias",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario
				})
		})
	},

	
	eliminarcategoria(p_email, p_usuario, p_ccocategoria) {
		return axios
			.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_corredores.eliminarcategoria",
			"p_args_in": JSON.stringify({
			"p_usuario": p_usuario,
			"p_ccocategoria": p_ccocategoria
			})
		})
	},
}